export class Setting{
    public FullAlias:string;
    public Alias:string;
    public Branch:string;
    public Domain:string;
    public CreatePkAlias:boolean;
    public Role:string;
    public IsIdAutoGenerated:boolean;
    public Prefix:string;
    public AddressDescription:string;
    public Notify:string;
    public AppType:string;

    public ReportGeneration:boolean;
    
    public ReportSend:boolean;
    public ReportStorage:boolean;

    public GbPkPairingNo:number;

    public Source : string;
    
    constructor(){
        this.GbPkPairingNo = -1;
        this.CreatePkAlias = false; 
        this.IsIdAutoGenerated = false;
    }
    
}